import ResearchAssignment from './ResearchAssignment';

export default ResearchAssignment;
